var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"list__item"},[_c('h3',{staticClass:"list__item-headline",domProps:{"innerHTML":_vm._s(_vm.data.Lanqkey01)}}),(_vm.debug.visible)?_c('DebugItem',{attrs:{"data":_vm.data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }